import React, { useRef } from "react"
import {
  Modal,
  Typography,
  Space,
  Button,
  Alert,
  message,
} from "@mimber/ui-web"
import { usePublishDonationPage } from "@mimber/client/mimber-organization"
import type { PublishDonationPageModalProps } from "./PublishDonationPageModal.types"

const { Paragraph } = Typography

export const PublishDonationPageModal: React.FunctionComponent<
  PublishDonationPageModalProps
> = ({ donationPage, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)

  const mutation = usePublishDonationPage(donationPage.uuid, {
    onSuccess: () => {
      message.success("Donation page published")
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to publish donation page: ${error.message}`)
    },
  })

  return (
    <Modal title="Publish Donation Page" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Alert
              type="info"
              showIcon
              title="This donation page will become available to donors"
              description="Publishing makes this page available for live donations."
            />
            <Paragraph>
              Publish <strong>{donationPage.title}</strong> now?
            </Paragraph>
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button onClick={close} disabled={mutation.isPending}>
                Cancel
              </Button>
              <Button
                type="primary"
                loading={mutation.isPending}
                onClick={() => mutation.mutate()}
              >
                Publish Donation Page
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
